export const ITEMS_BY_PAGE_OPTIONS = [
    5,
    10,
    20,
    50,
    100,
]